/* ==========================================================================
   Photo mega menu (Rubytubes / Focal) — original vanilla JS, no dependencies.
   <rt-photo-nav>         : desktop hover/focus category switching + a11y
   <rt-photo-nav-mobile>  : mobile single-open accordions
   ========================================================================== */
(function () {
  'use strict';

  var HOVER_DELAY = 70; // ms — small delay so brushing across the rail doesn't flicker
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- DESKTOP */
  if (!customElements.get('rt-photo-nav')) {
    customElements.define('rt-photo-nav', class extends HTMLElement {
      connectedCallback() {
        this.cats = Array.prototype.slice.call(this.querySelectorAll('.rt-photonav__cat'));
        this.panes = Array.prototype.slice.call(this.querySelectorAll('.rt-photonav__pane'));
        if (!this.cats.length) return;

        this.delay = reduceMotion ? 0 : HOVER_DELAY;
        this.timer = null;
        this.active = Math.max(0, this.cats.findIndex(function (c) { return c.classList.contains('is-rt-active'); }));

        this.onEnter = this.onEnter.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.cats.forEach(function (cat, i) {
          cat.setAttribute('tabindex', i === this.active ? '0' : '-1');
          cat.addEventListener('mouseenter', this.onEnter);
          cat.addEventListener('focus', this.onFocus);
        }, this);

        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseleave', function () {
          if (this.timer) { clearTimeout(this.timer); this.timer = null; }
        }.bind(this));

        this.setActive(this.active, false);
      }

      idx(el) { return this.cats.indexOf(el); }

      onEnter(e) {
        var i = this.idx(e.currentTarget);
        if (this.timer) clearTimeout(this.timer);
        if (this.delay === 0) { this.setActive(i, false); return; }
        this.timer = setTimeout(function () { this.setActive(i, false); }.bind(this), this.delay);
      }

      onFocus(e) {
        if (this.timer) { clearTimeout(this.timer); this.timer = null; }
        this.setActive(this.idx(e.currentTarget), false);
      }

      onKeydown(e) {
        if (e.key === 'Escape') { this.close(); return; }
        var t = e.target;
        if (!t.classList || !t.classList.contains('rt-photonav__cat')) return;

        var i = this.idx(t);
        var last = this.cats.length - 1;
        var rtl = getComputedStyle(this).direction === 'rtl';
        var next = null;

        switch (e.key) {
          case 'ArrowDown': next = i + 1; break;
          case 'ArrowUp':   next = i - 1; break;
          case 'ArrowRight': next = rtl ? i - 1 : i + 1; break;
          case 'ArrowLeft':  next = rtl ? i + 1 : i - 1; break;
          case 'Home': next = 0; break;
          case 'End':  next = last; break;
          default: return;
        }
        e.preventDefault();
        if (next < 0) next = last;
        if (next > last) next = 0;
        this.setActive(next, true);
      }

      setActive(i, moveFocus) {
        if (i < 0 || i >= this.cats.length) return;
        this.active = i;
        this.cats.forEach(function (cat, idx) {
          var on = idx === i;
          cat.classList.toggle('is-rt-active', on);
          cat.setAttribute('tabindex', on ? '0' : '-1');
        });
        this.panes.forEach(function (pane, idx) {
          pane.classList.toggle('is-rt-active', idx === i);
        });
        if (moveFocus) this.cats[i].focus();
      }

      close() {
        var root = this.closest('.mega-menu');
        var trigger = root ? document.querySelector('[aria-controls="' + root.id + '"]') : null;
        if (trigger) trigger.focus(); // returns focus; theme + :focus-within collapse the menu
      }
    });
  }

  /* ----------------------------------------------------------------- MOBILE */
  if (!customElements.get('rt-photo-nav-mobile')) {
    customElements.define('rt-photo-nav-mobile', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(e) {
        var btn = e.target.closest('[data-rt-mp-toggle], [data-rt-mp-cat]');
        if (!btn || !this.contains(btn)) return;
        e.preventDefault();

        var isCat = btn.hasAttribute('data-rt-mp-cat');
        var region = document.getElementById(btn.getAttribute('aria-controls'));
        if (!region) return;

        var willOpen = btn.getAttribute('aria-expanded') !== 'true';

        // Single-open: when opening a category, close its siblings
        if (isCat && willOpen) {
          this.querySelectorAll('[data-rt-mp-cat][aria-expanded="true"]').forEach(function (other) {
            if (other === btn) return;
            other.setAttribute('aria-expanded', 'false');
            var r = document.getElementById(other.getAttribute('aria-controls'));
            if (r) r.classList.remove('is-rt-open');
          });
        }

        btn.setAttribute('aria-expanded', String(willOpen));
        region.classList.toggle('is-rt-open', willOpen);
      }
    });
  }
})();
